import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

export enum VWLVertragsArt {
  GELDSPAREN = 'Geldsparen',
  BAUSPAREN = 'Bausparen',
  VERMOEGENSBETEILIGUNG = 'Vermögensbeteiligung',
}

@Entity()
export class ANVermoegenswirksameLeistungen extends AdornisEntity {
  static override _class = 'ANVermoegenswirksameLeistungen';

  @Field(() => Boolean, { default: v => v ?? false })
  vermoegenswirksameLeistungIstVorhanden: Maybe<boolean>;

  @Field(() => ID)
  arbeitgeberblattID: Maybe<string>;

  @Field(() => Float)
  vermoegensbildung: Maybe<number>;

  @Field(() => Float)
  vermoegensbildungArbeitgeberAnteil: Maybe<number>;

  @Field(() => Boolean, { default: v => v ?? false })
  lastschrifteinzug: Maybe<boolean>;

  @Field(() => String)
  iban: Maybe<string>;

  @Field(() => String)
  institut: Maybe<string>;

  @Field(() => String)
  vertragsnummer: Maybe<string>;

  @Field(() => String)
  vertragsart: Maybe<VWLVertragsArt>;

  @Field(() => Boolean, { default: v => v ?? false })
  isAltersvermoegenswirksameLeistung: Maybe<boolean>;

  @Field(() => Date)
  vertragBegin: Maybe<Date>;

  @Field(() => Date)
  vertragEnd: Maybe<Date>;
}
